import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { CollectionInterface } from "@core/interfaces/collection.interface";

@Component({
  selector: "astrobin-collection-image-count",
  template: `
    <ng-container *ngIf="isOwner">
      <ng-container
        *ngIf="
          collection.imageCountIncludingWip === 0 &&
          (!collection.imageCountIncludingWipIncludingNested ||
            collection.imageCountIncludingWipIncludingNested === 0 ||
            !collection.nestedCollectionCount)
        "
      >
        <span translate="No images"></span>
      </ng-container>

      <ng-container
        *ngIf="
          collection.imageCountIncludingWip === 0 &&
          collection.imageCountIncludingWipIncludingNested > 0 &&
          collection.nestedCollectionCount
        "
      >
        <ng-container *ngIf="collection.nestedCollectionCount === 1">
          <span
            [translate]="'{{ 0 }} images in 1 subcollection'"
            [translateParams]="{ '0': collection.imageCountIncludingWipIncludingNested | numberSuffix }"
          ></span>
        </ng-container>
        <ng-container *ngIf="collection.nestedCollectionCount > 1">
          <span
            [translate]="'{{ 0 }} images in {{ 1 }} subcollections'"
            [translateParams]="{
              '0': collection.imageCountIncludingWipIncludingNested | numberSuffix,
              '1': collection.nestedCollectionCount | numberSuffix
            }"
          ></span>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="collection.imageCountIncludingWip === 1">
        <span translate="1 image"></span>
      </ng-container>

      <ng-container *ngIf="collection.imageCountIncludingWip > 1">
        <span
          [translate]="'{{ 0 }} images'"
          [translateParams]="{ '0': collection.imageCountIncludingWip | numberSuffix }"
        ></span>
        <ng-container
          *ngIf="
            collection.imageCountIncludingWipIncludingNested &&
            collection.imageCountIncludingWipIncludingNested > collection.imageCountIncludingWip &&
            collection.nestedCollectionCount
          "
        >
          <ng-container *ngIf="collection.nestedCollectionCount === 1">
            <span
              [translate]="'(+{{ 0 }} in 1 subcollection)'"
              [translateParams]="{
                '0': collection.imageCountIncludingWipIncludingNested - collection.imageCountIncludingWip | numberSuffix
              }"
              class="nested-count"
            ></span>
          </ng-container>
          <ng-container *ngIf="collection.nestedCollectionCount > 1">
            <span
              [translate]="'(+{{ 0 }} in {{ 1 }} subcollections)'"
              [translateParams]="{
                '0':
                  collection.imageCountIncludingWipIncludingNested - collection.imageCountIncludingWip | numberSuffix,
                '1': collection.nestedCollectionCount | numberSuffix
              }"
              class="nested-count"
            ></span>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="!isOwner">
      <ng-container
        *ngIf="
          collection.imageCount === 0 &&
          (!collection.imageCountIncludingNested ||
            collection.imageCountIncludingNested === 0 ||
            !collection.nestedCollectionCount)
        "
      >
        <span translate="No images"></span>
      </ng-container>

      <ng-container
        *ngIf="
          collection.imageCount === 0 && collection.imageCountIncludingNested > 0 && collection.nestedCollectionCount
        "
      >
        <ng-container *ngIf="collection.nestedCollectionCount === 1">
          <span
            [translate]="'{{ 0 }} images in 1 subcollection'"
            [translateParams]="{ '0': collection.imageCountIncludingNested | numberSuffix }"
          ></span>
        </ng-container>
        <ng-container *ngIf="collection.nestedCollectionCount > 1">
          <span
            [translate]="'{{ 0 }} images in {{ 1 }} subcollections'"
            [translateParams]="{
              '0': collection.imageCountIncludingNested | numberSuffix,
              '1': collection.nestedCollectionCount | numberSuffix
            }"
          ></span>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="collection.imageCount === 1">
        <span translate="1 image"></span>
      </ng-container>

      <ng-container *ngIf="collection.imageCount > 1">
        <span [translate]="'{{ 0 }} images'" [translateParams]="{ '0': collection.imageCount | numberSuffix }"></span>
        <ng-container
          *ngIf="
            collection.imageCountIncludingNested &&
            collection.imageCountIncludingNested > collection.imageCount &&
            collection.nestedCollectionCount
          "
        >
          <ng-container *ngIf="collection.nestedCollectionCount === 1">
            <span
              [translate]="'(+{{ 0 }} in 1 subcollection)'"
              [translateParams]="{ '0': collection.imageCountIncludingNested - collection.imageCount | numberSuffix }"
              class="nested-count"
            ></span>
          </ng-container>
          <ng-container *ngIf="collection.nestedCollectionCount > 1">
            <span
              [translate]="'(+{{ 0 }} in {{ 1 }} subcollections)'"
              [translateParams]="{
                '0': collection.imageCountIncludingNested - collection.imageCount | numberSuffix,
                '1': collection.nestedCollectionCount | numberSuffix
              }"
              class="nested-count"
            ></span>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  `,
  styles: [
    `
      .nested-count {
        margin-left: 0.25rem;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CollectionImageCountComponent {
  @Input() collection: CollectionInterface;
  @Input() isOwner: boolean;
}
